import { c as _c } from "react/compiler-runtime";
import { IcoCloseSmall16 } from '@onefootprint/icons';
import type { PillProps } from '../pill';
import Pill from '../pill';
const ClearPill = t0 => {
  const $ = _c(7);
  const {
    children,
    disabled,
    onClick
  } = t0;
  const t1 = disabled ? "quaternary" : "tertiary";
  let t2;
  if ($[0] !== t1) {
    t2 = <IcoCloseSmall16 color={t1} />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children || $[3] !== disabled || $[4] !== onClick || $[5] !== t2) {
    t3 = <Pill onClick={onClick} disabled={disabled} type="button">{t2}{children}</Pill>;
    $[2] = children;
    $[3] = disabled;
    $[4] = onClick;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export default ClearPill;